import { useEffect, useRef } from 'react';
import { isIOS, isAndroid, isNative } from '../utils/platform';

export default function useNativeSetup() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    (async () => {
      try {
        if (isIOS() || isAndroid()) {
          const { StatusBar, Style } = await import('@capacitor/status-bar');
          await StatusBar.setStyle({ style: Style.Dark });
          if (isAndroid()) await StatusBar.setBackgroundColor({ color: '#0a0e1a' });
        }

        if (isNative()) {
          const { SplashScreen } = await import('@capacitor/splash-screen');
          await SplashScreen.hide();
        }

        if (isAndroid()) {
          const { App } = await import('@capacitor/app');
          App.addListener('backButton', ({ canGoBack }) => {
            if (canGoBack) window.history.back();
            else App.exitApp();
          });
        }

        if (isNative()) {
          const { App } = await import('@capacitor/app');
          App.addListener('appUrlOpen', async ({ url }) => {
            if (url?.includes('/auth/callback')) {
              try {
                const { Browser } = await import('@capacitor/browser');
                await Browser.close();
              } catch {
                /* @capacitor/browser may not be installed — non-fatal */
              }
            }
          });
        }
      } catch (err) {
        console.warn('Native setup error (non-fatal):', err);
      }
    })();
  }, []);
}
